const addBtn = document.querySelectorAll('[data-js-add-stofstaal]')
const selectionStofstaal  = document.querySelector('[data-js-selected-stofstaal]');
const removeBtn = document.querySelectorAll('[data-js-remove-stofstaal]')
const selectedCount = document.querySelector('[data-js-stofstaal-selected-count]');
let arrNames = [];
let arrCodes = [];

const removeItem = selected => {
    const selectedToRemove = document.querySelector('._selectedToRemove');
    const {
        code,
        name,
    } = selected.dataset;
  
    arrNames = arrNames.filter(item => item !== name);
    arrCodes = arrCodes.filter(item => item !== code);
    
    const removeProductName = JSON.stringify(arrNames)
    const removedPriductCoode = JSON.stringify(arrCodes)
    
    selectionStofstaal.setAttribute("data-names", removeProductName)
    selectionStofstaal.setAttribute("data-codes", removedPriductCoode)

    selectedToRemove.remove();

    addBtn.forEach(btn => {
        if (btn.dataset.code === selectedToRemove.dataset.code ) {
            btn.disabled = false;
            btn.classList.remove('selected');
            btn.querySelector('span.text').innerHTML = js_translations['StofstaalBtnAdd'];
        }
    });
}

const appendedImage = (imgSrc, code, name) => {
    const container = document.querySelectorAll('[data-js-selection-images] div')
    let img = document.createElement('img');
    img.src = imgSrc;
    img.setAttribute('data-code', code)
    img.setAttribute('data-name', name)

    container.forEach(item => {
        if (!item.childNodes.length) {
            item.appendChild(img);
        }
    })

    const items = document.querySelectorAll('[data-js-selection-images] img');
    items.forEach(item =>{
        item.addEventListener('click', (e) => {

            removeBtn.forEach(btn => {
                btn.setAttribute('data-code', e.currentTarget.dataset.code)
                btn.setAttribute('data-name', e.currentTarget.dataset.name)
            });

            items.forEach(item => item.classList.remove('_selectedToRemove'));               
            item.classList.add('_selectedToRemove');
        });
    });
}

const selectItems = (e) => {
    e.preventDefault();
    const productCode = e.currentTarget.dataset.code;
    const productName = e.currentTarget.dataset.name;
    const productImg = e.currentTarget.dataset.img;
    
    e.currentTarget.classList.add('selected');
    e.currentTarget.disabled = true;
    e.currentTarget.querySelector('span.text').innerHTML = js_translations['StofstaalBtnAdded'];
   
    arrNames.push(productName);
    arrCodes.push(productCode);

    appendedImage(productImg, productCode, productName);

    const selectedProductName = JSON.stringify(arrNames)
    const selectedProductCode = JSON.stringify(arrCodes)

    selectionStofstaal.setAttribute("data-names", selectedProductName)
    selectionStofstaal.setAttribute("data-codes", selectedProductCode)
}

const watchActiveCount = () => {
    const config = { childList: true, subtree: true };
    const target = document.querySelectorAll('.stofstaal-modal__items');

    [...target].forEach(item => {
        const listenForEvents = () => {

            // Disable rest of the buttons if selected length is 5
            if ([...item.querySelectorAll('[data-js-add-stofstaal].selected')].length >= 5) {
                addBtn.forEach(btn => btn.disabled = true);
            } else {
                document.querySelectorAll('[data-js-add-stofstaal]:not(.selected)').forEach(btn => btn.disabled = false);
            }

            // Enable main button if selected 
            if ([...item.querySelectorAll('[data-js-add-stofstaal].selected')].length) {
                selectionStofstaal.disabled = false
            } else {
                selectionStofstaal.disabled = true
            }

            // Update count
            selectedCount.innerHTML = [...item.querySelectorAll('[data-js-add-stofstaal].selected')].length;
        }

        const observer = new MutationObserver(listenForEvents);
        observer.observe(item, config);
    });
}

if (addBtn.length) {
    addBtn.forEach(btn => {
        btn.addEventListener('click', (e) => selectItems(e))
    });
    
    removeBtn.forEach(btn => {
        btn.addEventListener('click', (e) => removeItem(e.currentTarget));
    });
    
    watchActiveCount();
}
